export default __webpack_public_path__ + "station-defect-bearing-gray.png?9507a33891d9c4cd4eba1eeb2494e411";